export default {
  title: '黃儁弼♥︎韓希松 2019.04.13 2019.04.13 周六下午 3:00 Grand Hill Convention 1F Floria',
  husband: ['黃 ', '儁弼'],
  wife: ['韓 ', '希松'],
  date: '2019.04.13 周六下午 3:00',
  location: 'Grand Hill Convention 1F Floria',
  locations: {
    address: 'Address',
    addressContent: 'Seoul 602 Yeoksam-ro, Daecheon-dong, Gangnam-gu, Seoul, <br /> <strong>Grand Hill Convention</strong>',
    subway: 'Subway',
    subwayContent: 'Take the shuttle bus to Exit 1 of Samsung Station on Line 2 or <br />walk 5 minutes from Exit 2',
    bus: 'Bus',
    busContent: 'Main bus 143, 146, 341, 360, 401 <br />Branch bus 2413, 3411, 3422, 4318, 4419, 917, 11-3 <br />Wide area bus 9407, 6900',
  },
  invite: 'Dear',
  greeting: [
    '四月份的某一天',
    '在各位的见证下 手牵着手',
    '约定好一起走的路',
    '永远带着此刻的心情，一起走下去',
    '愿得到各位的祝福'],
  telWho: ['新郎', '新娘'],
  money: '礼金',
  moneySend: '送贺礼',
  tossAppSet: '安装Toss应用程序',
  deposit: '充币地址',
  copy: '复制',
  huobi: '直接跳转至火币交易所'
};


// WEBPACK FOOTER //
// ./src/locales/zh-CN/home.ts